import { getNegationPrefix } from '../common/negatable.js';
import { getOperatorSymbol } from '../common/operator.js';
export function buildStringField(config) {
    return {
        toQuerySyntax() {
            const { field } = config;
            const prefix = getNegationPrefix(config);
            const operator = getOperatorSymbol(config.operator);
            const processed = config.values.map((value) => `"${value}"`);
            const values = processed.length === 1 ? processed[0] : `(${processed.join(',')})`;
            return `${prefix}@${field}${operator}${values}`;
        },
    };
}
